import styled from 'styled-components'
import { grid } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { Flex } from 'Components/UI'

export const Container = styled(Flex).attrs({
  width: 1,
  justifyContent: 'center',
  mt: [32, 96],
})`
  position: relative;
`

export const StatsGrid = styled.div.attrs({
  gridTemplateColumns: ['1fr', '1fr', 'repeat(3, 1fr)'],
})`
  display: grid;
  grid-auto-rows: auto;
  width: 100%;
  gap: ${themeGet('space.3')}px;

  ${grid}
`

export const StatPlate = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${themeGet('space.4')}px;
  border-radius: 8px;
  border: solid 1px ${themeGet('colors.softPeach')};
`
